var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35156 14.4218C6.46094 17.0703 2.92969 17.0703 2.92969 17.0703C2.92969 17.0703 2.92969 13.539 5.57812 12.6484",
    stroke: "#F8F9FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 8.23437L10 13.5391L6.46094 10L11.7656 4.69531C13.7734 2.6875 15.7813 2.71094 16.6406 2.83594C16.7732 2.85363 16.8963 2.91447 16.9909 3.00907C17.0855 3.10367 17.1464 3.22677 17.1641 3.35937C17.2891 4.21875 17.3125 6.22656 15.3047 8.23437Z",
    stroke: "#F8F9FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4219 9.11722V14.1641C14.4195 14.3289 14.3521 14.4862 14.2344 14.6016L11.7109 17.1328C11.6309 17.2128 11.5306 17.2695 11.4208 17.297C11.3111 17.3244 11.1959 17.3216 11.0876 17.2887C10.9794 17.2558 10.882 17.1941 10.8061 17.1103C10.7301 17.0264 10.6783 16.9235 10.6562 16.8125L10 13.5391",
    stroke: "#F8F9FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.882 5.57809H5.83515C5.67029 5.58044 5.51304 5.64784 5.39765 5.76559L2.8664 8.28903C2.78643 8.36909 2.7297 8.46935 2.70226 8.57913C2.67481 8.6889 2.67768 8.80407 2.71057 8.91234C2.74345 9.02061 2.80511 9.11793 2.88896 9.1939C2.97282 9.26987 3.07573 9.32165 3.18671 9.34372L6.46015 9.99997",
    stroke: "#F8F9FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket_launch.3c04469221b9609f4bb8ffb39f081acb.svg";
export { ForwardRef as ReactComponent };